import { Document, DocumentSubType } from '../../../graphql/graphql';
import { getSubmissionLastItemStatus } from './sickLeaveStatusMap.helper';

export function checkForSubmission(
	submissions: Document[] | undefined | null,
	documentSubType: DocumentSubType | string,
	acceptableStatuses: readonly string[],
): boolean {
	if (!submissions?.length || !acceptableStatuses.length) {
		return false;
	}

	for (const submission of submissions) {
		const status = getSubmissionLastItemStatus(submission);

		if (
			submission.subType === documentSubType &&
			status &&
			acceptableStatuses.includes(status)
		) {
			return true;
		}
	}

	return false;
}
